import {
  AUTHENTICATE, DEAUTHENTICATE, REAUTHENTICATE, VERIFY,
} from 'reduxStore/types';

const initialState = {
  isLoggedIn: false,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case AUTHENTICATE:
      return { ...state, isLoggedIn: true, ...action.payload };
    case VERIFY:
      return initialState;
    case DEAUTHENTICATE:
      return initialState;
    case REAUTHENTICATE:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      };
    default:
      return state;
  }
};
